import topsort from './topsort.js';

function isAcyclic (g) {
  try {
    topsort(g);
  } catch (e) {
    if (e instanceof topsort.CycleException) {
      return false
    }

    throw e
  }

  return true
}

export { isAcyclic as default };
//# sourceMappingURL=is-acyclic.js.map
